import { render } from "./notification-page.vue?vue&type=template&id=7527cae0&scoped=true"
import script from "./notification-page.vue?vue&type=script&lang=js"
export * from "./notification-page.vue?vue&type=script&lang=js"

import "./notification-page.vue?vue&type=style&index=0&id=7527cae0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7527cae0"]])

export default __exports__